var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoading)?_c('div',[_c('div',{staticClass:"wrapper-loading"},[(!_vm.organizationName)?_c('div',{staticClass:"loading"}):_c('div',{staticClass:"loading-text"},[_vm._v(" "+_vm._s(_vm.organizationName)+" "),_c('h2',[_vm._v(_vm._s(_vm.subTitle))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }